export default __webpack_public_path__ + "static/media/home1.f8e9de53.jpg";